var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82812 6.9296C2.83773 4.10255 5.1373 1.81855 7.96436 1.82816C10.7914 1.83776 13.0754 4.13733 13.0658 6.96439V7.02236C13.031 8.86004 12.0049 10.5586 10.747 11.8861C10.0275 12.6332 9.22413 13.2946 8.35276 13.8571C8.11977 14.0587 7.77416 14.0587 7.54117 13.8571C6.24217 13.0116 5.10208 11.9442 4.17305 10.7035C3.34503 9.62166 2.8749 8.30856 2.82813 6.947L2.82812 6.9296Z",
    stroke: "#714FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.94527,
    cy: 7.0312,
    rx: 1.64058,
    ry: 1.64058,
    stroke: "#714FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.7bfc1b668ec0f9697f20330a874e9814.svg";
export { ForwardRef as ReactComponent };